import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import AdminLogin from './components/AdminLogin';
import DefaultDashboard from './components/DefaultDashboard';
import ManageCategory from './pages/ManageCategory';
import ManageVendor from './pages/ManageVendor';
import CreateVendor from './pages/CreateVendor';
import UpdateVendor from './pages/UpdateVendor';
import ManagePackage from './pages/ManagePackage';
import CreatePackage from './pages/CreatePackage';
import UpdatePackage from './pages/UpdatePackage';
import ManagePage from './pages/ManagePage';
import ManageSubPage from './pages/ManageSubPage';
import CreateSubPage from './pages/CreateSubPage';
import UpdateSubPage from './pages/UpdateSubPage';
import ManageLocation from './pages/ManageLocation';
import CreateLocation from './pages/CreateLocation';
import UpdateLocation from './pages/UpdateLocation';
import ManageItinerary from './pages/ManageItinerary';
import CreateItinerary from './pages/CreateItinerary';
import UpdateItinerary from './pages/UpdateItinerary';
import ManageUser from './pages/ManageUser';
import DisplayPage from './pages/DisplayPage';
import CreateMainPage from './pages/CreateMainPage';
import UpdateMainPage from './pages/UpdateMainPage';
import ManageDepatureCity from './pages/ManageDepartureCity';
import ManageAirlines from './pages/ManageAirlines';
import useInactivityLogout from './custonHook/useInactivityLogout';
// import CreatePackageInPage from './pages/CreatePackageInPage';
import ManagePlan from './pages/ManagePlan';
import ActiveServiceProviders from './pages/ActiveServiceProviders';
import './App.css';
import PackageApproval from './pages/PackageApproval';
import ManageMetaTags from './pages/ManageMetaTags';
import Blog from './pages/Blog';
import ManageFaq from './pages/ManageFaq';
import ManageAdminUser from './pages/ManageAdminUser';
import ManageUserPermissions from './pages/ManageUserPermissions';
import FiltterPage from './components/FiltterPage';
import TotalUmrahPackages from './components/filterUmrah/TotalUmrahPackages';
import TotalHajjPackages from './components/filterUmrah/TotalHajjPackages';
import LeadDashboard from './components/LeadDashboard';
import CreatePackageInPage from './pages/CreatePackageInPage';
import UpdatePackageInPage from './pages/UpdatePackageInPage';
import ShowApprovePackage from './pages/ShowApprovePackage';
import CreateUpdateMetatag from './pages/CreateUpdateMetatag';
import ManageBlog from './pages/ManageBlog';
import AddUser from './pages/AddUser';
import UpdateUser from './pages/UpdateUser';

import CreateMainPageInPage from './pages/CreateMainPageInPage';
import UpdateMainPageInPage from './pages/UpdateMainPageInPage';
import CreatePlanInPage from './pages/CreatePlanInPage';
import UpdatePlanInPage from './pages/UpdatePlanInPage';
import CreateLocationInPage from './pages/CreateLocationInPage';
import UpdateItineraryInPage from './pages/UpdateItineraryInPage';
import CreateItineraryInPage from './pages/CreateItineraryInPage';

import CreateUpdateFaqs from './components/FAQ/CreateUpdateFaqs';


function App() {
  const admin = JSON.parse(localStorage.getItem('admin')) || null;
  const [isLoggedIn, setIsLoggedIn] = useState(admin);


  const handleLogin = (data) => {
    setIsLoggedIn(data);
  };

  const handleLogout = () => {
    localStorage.removeItem("admin");
    localStorage.removeItem("expiresAt");
    setIsLoggedIn(null);
  };

  useInactivityLogout(isLoggedIn ? handleLogout : () => {}, 5 * 60 * 1000);


  useEffect(() => {

  const interval = setInterval(() => {
    const expiresAt = JSON.parse(localStorage.getItem("expiresAt"));

    // If expiresAt does NOT exist → force logout
    if (!expiresAt) {
      setIsLoggedIn(null);
      localStorage.removeItem("admin");
      return;
    }

    // If expired → logout
    if (Date.now() > expiresAt) {
      localStorage.removeItem("admin");
      localStorage.removeItem("expiresAt");
      setIsLoggedIn(null);
    }
  }, 30 * 1000);

  return () => clearInterval(interval);
}, []);



  return (
    <Router>
      <div className='app'>
        {isLoggedIn ? (
          <>
            <div className='app-content'>
              <Sidebar />
              <main className='main-content'>
                <Header handleLogin={handleLogin} />
                <Routes>
                  <Route path="/" element={<Navigate to="/dashboard" replace />} />
                  <Route path='/dashboard' element={<DefaultDashboard handleLogin={handleLogin} />}  />
                  <Route path='/manage-lead' element={<ManageUser />} />
                  <Route path="/manage-vendor" element={<ManageVendor />} />
                  <Route path="/manage-category" element={<ManageCategory />} />
                  <Route path="/create-vendor" element={<CreateVendor />} />
                  <Route path="/update-vendor/:id" element={<UpdateVendor />} />

                  <Route path='/manage-package' element={<ManagePackage />} />
                  <Route
                    path="/manage-package/create"
                    element={<CreatePackageInPage />}
                  />
                  <Route
                    path="/manage-package/edit/:id"
                    element={<UpdatePackageInPage />}
                  />

                  <Route path='/create-package' element={<CreatePackage />} />
                  <Route path='/update-package/:id' element={<UpdatePackage />} />
                  <Route path='/update-package/:id' element={<UpdatePackage />} />


                  <Route path='package-approval' element={<PackageApproval />} />
                  <Route
                    path="/package-approval/view/:id"
                    element={<ShowApprovePackage />}
                  />

                  <Route
                    path="/package-approval/edit/:id"
                    element={<UpdatePackageInPage />}
                  />


                  <Route path='/plan-types' element={<ManagePlan />} />
                  <Route path='/plan-types/add' element={<CreatePlanInPage />} />
                  <Route path='/plan-types/edit/:id' element={<UpdatePlanInPage />} />

                  <Route path='/service-providers-plans' element={<ActiveServiceProviders />} />
                  {/* <Route path='pending-approval/' element={<PendingPackageApproval />} />
                  <Route path='/approved-packages/' element={<ApprovedPackages />} /> */}
                  <Route path='/manage-page' element={<ManagePage />} />
                  <Route path='/Manage-Departure-City' element={<ManageDepatureCity/>}/>
                  <Route path='/Manage-Airlines' element={<ManageAirlines/>}/>

                  <Route path='/manage-location' element={<ManageLocation />} />
                  <Route path='/create-location' element={<CreateLocationInPage />} />

                  <Route path='/manage-itinerary' element={<ManageItinerary />} />
                  <Route
                    path="/create-itinerary"
                    element={<CreateItineraryInPage />}
                  />

                  <Route
                    path="/update-itinerary/:id/:locationId"
                    element={<UpdateItineraryInPage />}
                  />

                  <Route path='/create-itinerary' element={<CreateItinerary />} />
                  <Route path='/update-itinerary/:id' element={<UpdateItinerary />} />
                  <Route path='/manage-subpage' element={<ManageSubPage />} />
                  <Route path='/create-subpage' element={<CreateSubPage />} />
                  <Route path='/update-subpage/:id' element={<UpdateSubPage />} />

                  <Route path='/display-pages' element={<DisplayPage />} />
                  <Route path='/display-pages/add' element={<CreateMainPageInPage />} />
                  <Route path='/display-pages/edit/:id' element={<UpdateMainPageInPage />} />

                  <Route path='/manage-metatags' element={<ManageMetaTags />} />
                  <Route
                    path="/manage-metatags/create"
                    element={<CreateUpdateMetatag />}
                  />

                  <Route
                    path="/manage-metatags/edit/:id"
                    element={<CreateUpdateMetatag />}
                  />

                  <Route path='/manage-faqs' element={<ManageFaq />} />
                  <Route
                    path="/faqs/add"
                    element={<CreateUpdateFaqs />}
                  />

                  <Route
                    path="/faqs/edit/:pageUrl"
                    element={<CreateUpdateFaqs />}
                  />

                  <Route path='/Blog' element={<Blog/>}/>
                  <Route
                    path="/blog/create"
                    element={<ManageBlog />}
                  />

                  <Route
                    path="/blog/edit/:id"
                    element={<ManageBlog />}
                  />

                  <Route path='/tour-opretor' element={<FiltterPage/>}/>
                  <Route path='/umrah-packages-list' element={<TotalUmrahPackages/>}/>
                  <Route path='/hajj-packages-list' element={<TotalHajjPackages/>}/>
                  <Route path='/lead-dashboard' element={<LeadDashboard/>}/>

                  {/* Manage Users */}
                  <Route path='/users' element={<ManageAdminUser />} />
                  <Route
                    path="/users/add"
                    element={<AddUser />}
                  />

                  <Route
                    path="/users/edit/:id"
                    element={<UpdateUser />}
                  />

                  <Route path='/user-permissions' element={<ManageUserPermissions />} />

                  {/* Manage Users */}
                </Routes>
              </main> 
            </div>
          </>
        ) : (
          <Routes>
            <Route path="/" element={<AdminLogin onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        )}
      </div>
    </Router>
  );
}

export default App;
